import { Icon, getSvgIcon } from '@helpers/icons';
import * as React from 'react';
import S from './FloatingBackgroundElements.styles';
const FloatingBackgroundElements = (props) => {
    return (React.createElement(React.Fragment, null, props.startPositions.map((pos, i) => (React.createElement(S.BackgroundElement, { key: `${props.keyFix}-${i}`, style: { '--x': pos.x, '--y': pos.y } }, getSvgIcon(Icon.BulletFill))))));
};
export default FloatingBackgroundElements;
